// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3CCTv","container":"styles_container__15r_1","title":"styles_title__3iW1U","wrapper":"styles_wrapper__3fKUB","answer":"styles_answer__1QmBA"};